import { render, staticRenderFns } from "./CourseView.vue?vue&type=template&id=40146fcf&scoped=true"
import script from "./CourseView.vue?vue&type=script&lang=js"
export * from "./CourseView.vue?vue&type=script&lang=js"
import style0 from "./CourseView.vue?vue&type=style&index=0&id=40146fcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40146fcf",
  null
  
)

export default component.exports